import { Component, OnInit } from '@angular/core';
import { Producto } from '../../../../models/producto';
import { ProductoService } from '../../../../services/producto.service';
import { UploadService } from '../../../../services/upload.service';
import { AuthService } from 'src/app/services/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CategoryService } from 'src/app/services/category.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DolarService } from 'src/app/services/dolar.service';

@Component({
  selector: 'app-addproducto',
  templateUrl: './addproducto.component.html',
  styleUrls: ['./addproducto.component.css'],
  providers: [ProductoService, UploadService, AuthService]
})
export class AddproductoComponent implements OnInit {
  formProduct!: FormGroup;
  public product: Producto;
  public status: string;
  public save_producto;
  public categorias: any = [];
  filteredOptions: Observable<any[]>;
  dolar_blue!: any;

  constructor(
    private formBuilder: FormBuilder,
    private _productoService: ProductoService,
    private _uploadService: UploadService,
    private authService: AuthService,
    private _categoryService: CategoryService,
    private _dolarService: DolarService,
  ) {
    this.product = new Producto();
    this.buildForm();
  }

  ngOnInit(): void {
    this.getCategorias();
    this.filteredOptions = this.formProduct.get('categoria').valueChanges.pipe(
      startWith(''),
      map((value: string) => value ? this._filter(value): this.categorias.slice()),
    );
    this._dolarService.getDolarBluePrice().subscribe(
      (res: any) => {
        console.log(res.venta)
        this.dolar_blue = res.venta;
      }
    )
  }

  private _filter(value: string): string[] {
    const filterValue = value?.toLowerCase();
    return this.categorias.filter(option => option.nombre.toLowerCase().includes(filterValue));
  }

  getCategorias() {
    this._categoryService.getCategories().subscribe(
      (res: any) => {
        if (res) {
          console.log(res);
          this.categorias = res.categoria
          this.formProduct.get('categoria').setValue('');
        }
      }
    )
  }

  onSubmit(form) {
    this.status = 'loading';
    let company = this.authService.getUID();
    this.product = this.formProduct.value;
    this.product.company = company;
    this.product.categoria = this.formProduct.value.categoria._id;
    this.product.precio_usd = parseFloat((this.formProduct.value.precio / this.dolar_blue).toFixed(2));
    this.product.costo_usd = parseFloat((this.formProduct.value.costo / this.dolar_blue).toFixed(2));
    this.product.personalizable = true;
    this.product.tienda = false;
    this.product.tiempo_elaboracion = 7;
    console.log(this.product);
    this._productoService.saveProducto(this.product).subscribe(
      response => {
        if (response) {
          this.save_producto = response.producto;
          this.status = 'succes';
          form.reset();
        }
        else { this.status = 'failed'; }
      },
      error => { console.log(<any>error); }
    );
  }

  displayFn(cliente: any): any {
    if (cliente && cliente.nombre) {
      return cliente && cliente.nombre
        ? cliente.nombre : '';
    }
  }
  
  private buildForm() {
    this.formProduct = this.formBuilder.group({
      // _id: [],
      nombre: [, Validators.required],
      descripcion: [],
      categoria: [],
      costo: [],
      costo_usd: [],
      precio: ['', Validators.required],
      precio_usd: [],
      details: [''],
      personalizable: [],
      tiempo_elaboracion: [],
      tienda: [],
    });
  }
}
